import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class DropDown {
	constructor(container, settings) {
		this.container = container instanceof Element ? container : document.body.querySelector(container);
		let defaults = { isOpen: true, clickOutside: true };
		this.settings = { ...defaults, ...settings };

		this.button = this.settings.button instanceof Element ? this.settings.button : this.container.querySelector(this.settings.button);
		if (this.settings.selection)
			this.selection = this.settings.selection instanceof Element ? this.settings.selection : this.container.querySelector(this.settings.selection);
		this.pane = this.settings.pane instanceof Element ? this.settings.pane : this.container.querySelector(this.settings.pane);
		if (this.options)
			this.options = this.container.querySelectorAll(this.settings.options);

		this.initiaPaneHeight = this.pane.clientHeight;

		this.open = this.settings.isOpen;
		this.hasClickOutside = this.settings.clickOutside;

		this.init();
		this.events();
	}

	init = () => {
		// Mark the scrollable pane so Lenis lets it scroll natively instead of
		// scrolling the page when the wheel/touch starts over an open dropdown.
		this.pane?.setAttribute('data-lenis-prevent', '');

		if (this.open) this.onShowPane();
		gsap.set(this.pane, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', height: 0 });

	}

	events = () => {
		this.button.addEventListener('click', this.onTogglePane);
		if (this.hasClickOutside) {
			document.addEventListener('click', this.onClickOutside);
		}

		this.button.addEventListener("keydown", this.onKeydown);
	}


	onKeydown = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault(); // prevent scrolling on Space
			this.button.click();
		}
	}

	onClickOutside = (e) => {
		const isClickInside = this.container.contains(e.target)
		if (!isClickInside) { this.onHidePane(); }
	}

	onTogglePane = () => {
		if (!this.open) this.onShowPane();
		else this.onHidePane();
	}

	onShowPane = () => {
		if (!this.open) {
			gsap.set(this.pane, { y: 0 });
		}

		this.open = true;
		this.container.classList.add('open');
		this.button.classList.add('open');

		gsap.to(this.pane, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', height: 'auto', duration: 1, ease: 'expo.out' });
	}

	onHidePane = () => {
		this.open = false;
		this.container.classList.remove('open');
		this.button.classList.remove('open');
		gsap.to(this.pane, {
			clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
			height: 0,
			duration: 0.7,
			ease: 'expo.out',
			/* onComplete: () => {
				gsap.set(this.pane, { y: 0 });
			} */
		});
	}

	resetOptions = () => {
		this.options.forEach(element => {
			element.classList.remove('active');
		});
	}

	onSetOption = (e) => {
		this.resetOptions();
		e.currentTarget.classList.add('active');
		this.onHidePane();

		if (this.selection) {
			this.selection.innerHTML = e.currentTarget.innerHTML;
		}
	}

	destroy = () => {
		this.button.removeEventListener('click', this.onTogglePane);
		this.button.removeEventListener("keydown", this.onKeydown);
		if (this.hasClickOutside) {
			document.removeEventListener('click', this.onClickOutside);
		}
	}
}